import httpClient from '@/api/http-client';

const endpoint = 'api/user-codes';

const userCodesService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (userCode) => httpClient.post(`${endpoint}`, userCode),

  update: (userCode) => httpClient.put(`${endpoint}/${userCode.id}`, userCode),

  // search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  delete: (userCode) => httpClient.delete(`${endpoint}/${userCode.id}`),
};

export default userCodesService;
